import { Billing } from 'ui/components/company/patterns/Billing/Billing';

/**
 * 売り手請求情報
 */
export const CompanyBilling: React.FC = () => {
    return <Billing />;
};
